import apiClient from '@/services/apiClient';

const P = '/pt-files';

const saveBlob = (blob, name) => {
  const url = URL.createObjectURL(blob);
  const a = Object.assign(document.createElement('a'), { href: url, download: name });
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

const blobDetail = async (e) => {
  const d = e?.response?.data;
  if (d instanceof Blob) {
    try { return JSON.parse(await d.text()).detail; } catch { return null; }
  }
  return d?.detail;
};

export const ptApi = {
  list: (params) => apiClient.get(P, { params }).then((r) => r.data.invoices),
  check: (nos) => apiClient.post(`${P}/check`, { invoice_nos: nos }).then((r) => r.data.results),
  download: async (invoiceNo) => {
    try {
      const r = await apiClient.get(`${P}/file`, { params: { invoice_no: invoiceNo }, responseType: 'blob' });
      const name = r.headers['x-file-name'] || 'PT.SEQ';
      saveBlob(r.data, name);
      return name;
    } catch (e) {
      const d = await blobDetail(e);
      const err = new Error(typeof d === 'string' ? d : d?.message || 'Could not download the PT file');
      err.problems = d?.problems || [];
      throw err;
    }
  },
  distributor: (cid) => apiClient.get(`${P}/distributors/${encodeURIComponent(cid)}`).then((r) => r.data),
  saveDistributor: (cid, codes) => apiClient.put(`${P}/distributors/${encodeURIComponent(cid)}`, codes).then((r) => r.data),
  learn: (cid, file) => {
    const f = new FormData();
    f.append('file', file);
    return apiClient.post(`${P}/distributors/${encodeURIComponent(cid)}/learn`, f, { headers: { 'Content-Type': undefined } }).then((r) => r.data);
  },
  codes: () => apiClient.get(`${P}/codes`).then((r) => r.data),
  saveCode: (kind, key, value) => apiClient.put(`${P}/codes`, { kind, key, value }).then((r) => r.data),
  gmail: () => apiClient.get(`${P}/gmail`).then((r) => r.data),
  gmailConnect: () => apiClient.get(`${P}/gmail/connect`, { params: { origin: window.location.origin } }).then((r) => r.data.url),
  gmailDisconnect: () => apiClient.delete(`${P}/gmail`).then((r) => r.data),
  saveCc: (cc) => apiClient.put(`${P}/mail-settings`, { cc }).then((r) => r.data),
  email: (invoiceNo, to, cc) => apiClient.post(`${P}/email`, { invoice_no: invoiceNo, to, cc }).then((r) => r.data),
};

export const splitEmails = (s) => String(s || '').split(/[\s,;]+/).map((x) => x.trim()).filter(Boolean);
